import React from 'react';
import BoletimWizardTitularModalForm from './dependencies/boletim_titular_modal'

import services from '../../services.js';
import BoletimRightTabData from './dependencies/boletim_right_tab_data'

class BoletimRightPanel extends React.Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            tab: "boletimExplorador",
            popUpForm: '',
            tabFormData: {},
            detailPopUp: '',
            entity_list: [],
            entity_list_object: {},
            tabShowData: {},
            ParcelRightTabDatadiv: null,
            optionsEntityList: '',
            error:null,
            outrosNoExplorer: null,
            outrosNoProperty: null
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        // this.getEntityList();
        //console.log("---------------->>>>>>>>>>>>>>>>>> did MOUNT")
        this.setState({
            tabFormData: this.props.Parcel
        }, () => this.setTabDetail(this.state.tab))
    }
    componentDidUpdate(prevProp) {
        if (prevProp.date !== this.props.date) {
            let outrosExplorerFromProps = {}
            let outrosPropertyFromProps = {}
            if(this.props.Parcel.boletimExplorador) {
                this.props.Parcel.boletimExplorador.map(entity => {
                    outrosExplorerFromProps = entity
                })
            }
            if(this.props.Parcel.boletimProprietario) {
                this.props.Parcel.boletimProprietario.map(entity => {
                    outrosPropertyFromProps = entity
                })
            } 
            this.setState({
                tabFormData: this.props.Parcel,
                outrosNoExplorer: outrosExplorerFromProps.nrOutrosExploradores,
                outrosNoProperty: outrosPropertyFromProps.nrOutrosProprietarios
            }, () => this.setTabDetail(this.state.tab))
        }
    }

    updateTabOnly = (tab) => {
        this.setState({
            tab
        }, () => this.setTabDetail(tab))
    }
 // Showing tab details
    setTabDetail = (tab) => {
        try {
            let tabFormData = { ...this.state.tabFormData }
            let tabShowData = { ...this.state.tabShowData }
            tabShowData[tab] = tabFormData[tab]            
            this.setState({
                tabShowData
            },()=>{
                this.ParcelRightTabData();
            })
        } catch (error) {
            this.setState({error})
        }
    }
    editState = () => {
        this.setState({
            tabShowData: {},
            tabFormData: {},
        })
    }

    insertClickPopUp = () => {
        try {
            this.setState({
                popUpForm: ""
            })
    
            let popUpForm = (
                <BoletimWizardTitularModalForm
                    tab={this.state.tab}
                    date={new Date()}
                    all_list={this.props.all_list}
                    closePopup={() => this.props.closePopup()}
                    parcelData={this.state.tabFormData[this.state.tab]}
                    Parcel={this.props.Parcel}
                    getPopUpFormState={(data, tab, outrosNoExplorer, outrosNoProperty) => this.getPopUpFormState(data, tab, outrosNoExplorer, outrosNoProperty)}
                    editState={()=> this.editState()}
                    outrosNoExplorer={this.state.outrosNoExplorer}
                    outrosNoProperty={this.state.outrosNoProperty}
                    // entity_list_object={this.state.entity_list_object}
                    // entityList={this.state.entity_list}
                    // getEntityList={(filter) => this.getEntityList(filter)}
                />
            )
            this.setState({
                popUpForm
            })
        } catch (error) {
            this.setState({error})
        }
    }


    getEntityName = async(row) => {
        let res = await services.EntityList.getEntityList('parcel', null, row.entnum)
        if(Object.keys(res.entity_row).length > 0){
            let name = res.entity_row[row.entnum].nome
            return name
        }else{
            return ''
        }
    }

    edicaoRightTabData = () => {
        this.insertClickPopUp()
    }
    ParcelRightTabData = () => {

        let ParcelRightTabDatadiv = (
            <BoletimRightTabData
                date={new Date()}
                tab={this.state.tab}
                tabShowData={this.state.tabShowData}
                outrosNoExplorer={this.state.outrosNoExplorer}
                outrosNoProperty={this.state.outrosNoProperty}
                insertClickPopUp={() => this.insertClickPopUp()}
                edicaoRightTabData={() => this.edicaoRightTabData()}
                closePopup ={() => this.props.closePopup()}
                // entity_list_object={this.state.entity_list_object}
            />
        )
        this.setState({
            ParcelRightTabDatadiv
        })
    }



    getPopUpFormState = (data, tab, outrosExplorer, outrosProperty) => {
        let tabFormData = { ...this.state.tabFormData }
        tabFormData[tab] = data;
        this.setState({
            tabFormData,
            outrosNoExplorer : outrosExplorer,
            outrosNoProperty: outrosProperty
        }, () => {
            this.props.handleSubmit(this.state.tabFormData)
            this.setTabDetail(tab)
        })
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        if(this.state.error){
            throw this.state.error
        }
        return (
            <div className="last-box">
                <div className="bg-white">
                    <div className="right-tab">
                        <ul className="nav nav-tabs d-flex ">
                            <li className="nav-item flex-fill">
                                <a className="nav-link piaDetails active"  onClick={() => this.updateTabOnly('boletimExplorador')} data-toggle="tab" href="#Exploradores">EXPLORADORES</a>
                            </li>
                            <li className="nav-item flex-fill">
                                <a className="nav-link piaDetails"  onClick={() => this.updateTabOnly('boletimProprietario')} data-toggle="tab" href="#PROPRIETARIOS">PROPRIETARIOS</a>
                            </li>
                        </ul>
                        {
                            this.state.ParcelRightTabDatadiv
                        }
                    </div>
                    <div className="modal left-popup" id="left-popup">
                        <div className="modal-dialog modal-sm">
                            {
                                this.state.popUpForm
                            }
                        </div>
                    </div>
                    <div className="modal left-popup" id="left-detail-popup">
                        <div className="modal-dialog modal-sm">
                            {
                                this.state.detailPopUp
                            }
                        </div>
                    </div>
                    
                </div>
            </div>
        )
    }
}


export default BoletimRightPanel;